<template>
  <div
    v-if="showModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
    role="dialog"
    aria-labelledby="dialogTitle"
  >
    <div class="confirm-dialog max-w-[720px] w-full shadow-lg rounded-md bg-zyxel-gray-200 mt-40">
      <div class="modal-header relative flex items-center p-8">
        <h2
          id="dialogTitle"
          class="text-center flex-grow"
        >
          {{ $t("messages.two_factor_auth.email_auth_title") }}
        </h2>
        <button
          class="absolute top-0 right-0 mt-2 mr-2"
          aria-label="Close"
          @click="closeModal"
        >
          <img
            src="@/assets/svg/icon_48px_close.svg"
            alt="Close icon"
          >
        </button>
      </div>
      <div class="w-full grow block h-px bg-stone-200" />
      <div class="modal-body m-6">
        <h3 class="text-left mt-6 mb-4">
          {{ $t('messages.two_factor_auth.otp_verified_title') }}
        </h3>
        <p class="mb-4">
          {{ $t('messages.two_factor_auth.email_auth_enable_success_description') }}
        </p>
        <div class="bg-zyxel-gray-900 p-4 rounded">
          <p class="b3 text-white">
            {{ $t('messages.two_factor_auth.main_mail') }}:
          </p>
          <p class="b2 text-white mb-4">
            {{ user.email }}
          </p>
        </div>
      </div>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="ml-3 mb-4 mr-4 button-primary min-w-[120px]"
          @click="closeModal"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-primary w-full mb-4"
          @click="closeModal"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Enable2FADialog',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    user: Object,
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    }
  },
}
</script>